import { regionalDAOlogo } from '../assets/icons.js'
import ABIS from '../../src/data/services/contractabis.js'
import { getRegionalDaos } from '../../src/data/services/dao.service.js'
import { getKips } from '../../src/data/services/kip.service.js'

/**
 * @type {{EXECUTIVE: string, MEMBER: string}}
 */
export const DaoRoles = {
  EXECUTIVE: 'executive',
  MEMBER: 'member',
}

export const KipRoles = {
  OWNER_ROLE: 'owner',
  ADMIN_ROLE: 'admin',
  EXECUTIVE_ROLE: 'executive',
  COURT_MEMBER_ROLE: 'court_member',
}

/** @returns {Promise<Object<string, DaoSettings>>} */
export async function updateSupportedDaos() {
  // TODO: this is handling an edge case where daos table not found
  // was returning an error object with a 200 status, this needs to be
  // fixed in the db but also some more robust error handling here was needed
  // come back to this after endpoint has been fixed
  let daos = []
  try {
    daos = await getRegionalDaos()
    // @ts-ignore
    if (daos?.errorName) {
      daos = []
    }
  } catch {
    console.error('error getting regional daos')
  }

  return daos.reduce((acc, dao) => {
    if (!dao?.governorAddress) {
      console.warn('Missing governorAddress for DAO:', dao)
      return acc
    }

    acc[dao.governorAddress] = {
      ...dao,
      daoName: dao.daoTokenName,
      address: dao.governorAddress,
      icon: regionalDAOlogo,
      daoAbi: ABIS.REGIONAL_DAO,
      daoTokenAbi: ABIS.REGIONAL_DAO_TOKEN,
      daoRegistryAbi: ABIS.REGISTRY,
      verificationAbi: ABIS.VERIFICATION,
      hasKipProcess: false,
      hasBuyback: true,
      isRegional: true,
    }
    return acc
  }, {})
}

/** @returns {Promise<Object<string, KipDaoSettings>>} */
export async function updateSupportedKips() {
  const kips = await getKips()
  if (!kips?.length) {
    return {}
  }
  return kips[0]
}
